let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6FG4T")).then(() => parcelRequire('6SU0N'));